import { render, staticRenderFns } from "./insurance_addoredit.vue?vue&type=template&id=56fb011e&"
import script from "./insurance_addoredit.vue?vue&type=script&lang=js&"
export * from "./insurance_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports